import {
  DEBOUNCEWAIT,
  DEBOUNCEOPTION
} from '@/constants/gobalConstants'
import {
  registerEvent,
  removeEvent
} from '@/common/registerEvent';
import { getBtn } from '@/api/login'
import { download, collectLog, queryBrandByName, } from '@/api/commonApi';
const _ = require('lodash');

export default {
  data() {
    return {
      // currentPage: 1, // 当前页
      pageSize: 20, // 每页条数
      totalSize: 0, // 总条数
      curMenuBtns: [], //当前菜单下所有有权限按钮
      systematicBtns: {},
    }
  },
  computed: {
    openMenuName() {
      if (this.$route.meta.menuName) {
        sessionStorage.setItem('menuName', this.$route.meta.menuName)
      }
      return this.$route.meta.menuName || sessionStorage.getItem('menuName')
    }
  },
  created() {
    this.systematicBtns = this.getSystematicBtns()
    this.getBtnsFn();
  },
  mounted() {
    if (this.systematicBtns) {
      this.systematicBtns = this.getSystematicBtns()
    }
  },
  methods: {
    /*form表单执行操作方法*/
    handleFn(handleFnName) {
      this[handleFnName]()
    },
    async getBtnsFn() {
      if (this.$route.meta.menuId) {
        sessionStorage.setItem('menuId', this.$route.meta.menuId)
      }
      const params = {
        'parentMenuId': this.$route.meta.menuId || sessionStorage.getItem('menuId')
      }
      const res = await getBtn(params)
      if (res.code == 0) {
        res.data && res.data.forEach(value => {
          this.curMenuBtns.push(value.btnParamNumber)
        })
      }
    },
    getSystematicBtns() {
      const systematicBtns = JSON.parse(sessionStorage.getItem('systematicBtns'));
      return systematicBtns && systematicBtns.reduce((value, item) => {
        value[this.$md5(item.name)] = this.$md5(this.openMenuName + item.name)
        return value;
      }, {})
    },
    registerEventFn() {
      registerEvent(document, 'keypress', (event) => {
        this.debounceBtn('queryListFn', '', event)
      });
    },
    removeEventFn() {
      removeEvent(document, 'keypress', (event) => {
        this.debounceBtn('queryListFn', '', event)
      })
    },
    /* 设置每页条数时触发的事件函数 */
    handleSizeChange(val) {
      this.ruleForm.currentPage = 1;
      this.pageSize = val;
      /* 如果table数据为空时，点击切换也不会执行查询方法 */
      if (this.tableData.length != 0) this.queryListFn();
    },
    /* 点击跳转当前页触发的事件函数 */
    handleCurrentChange(val) {
      this.ruleForm.currentPage = val;
      this.$store.dispatch('updataPageNum', this.ruleForm.currentPage);
      this.$set(this.$data, 'tableData', []);
      this.queryListFn();
    },
    // 重置
    resetForm(formName, idList) {
      this.$refs[formName].resetFields();
      if (!idList) {
        if (this.ruleForm.channelIdVal) this.ruleForm.channelIdVal = ''
      } else {
        typeof idList == 'string' ? this.ruleForm[idList] = '' : idList.forEach(value => { this.ruleForm[value] = '' })
      }
    },
    /*    func (Function): 要防抖动的函数。
    [wait=0] (number): 需要延迟的毫秒数。
    [options=] (Object): 选项对象。
    [options.leading=false] (boolean): 指定在延迟开始前调用。
    [options.maxWait] (number): 设置 func 允许被延迟的最大值。
    [options.trailing=true] (boolean): 指定在延迟结束后调用。*/
    debounceBtn: _.debounce(function(cb, params, e) {
      console.log(params)
      if (e && e.keyCode !== 13) {
        return;
      }
      params ? this[cb](...params) : this[cb]();
    }, DEBOUNCEWAIT, DEBOUNCEOPTION),
    // 防止影响全局，修改新增一个防抖函数
    newDebounceBtn: _.debounce(function(cb, params, e) {
      console.log(params)
      if (e && e.keyCode !== 13) {
        return;
      }
      params ? this[cb](params) : this[cb]();
    }, DEBOUNCEWAIT, DEBOUNCEOPTION),
    //跳转页面
    goTab(param) {
      this.$router.push(param);
      this.$refreshPage(param.path);
    },
    closePage(closeRoute, nextRoute) {
      this.$closePage(closeRoute, nextRoute)
    },
    /* 样表下载 */
    downloadTemplate(fileName) {
      download({ 'fileName': fileName }).then(data => {
        const content = data
        const blob = new Blob([content])
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      });
    },
    /* 样表下载 */
    downloadTemplateFromApi(fileName, urlApi) {
      urlApi({ 'fileName': fileName }).then(data => {
        const content = data
        const blob = new Blob([content])
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      });
    },
    collectLog(moduleName, btnName) {
      const params = {
        module: moduleName,
        name: btnName,
      }
      try {
        collectLog(params);
      } catch (e) {

      }
    },
  }
}
